/* eslint-disable import/prefer-default-export */
import { TRACK_TIME_TO_INTERACTIVE } from './types';

export const trackTimeToInteractive = (tti, pageName) => ({
  type: TRACK_TIME_TO_INTERACTIVE,
  payload: {
    name: `Time To Interactive - ${pageName}`,
    properties: {
      time_to_interactive: tti,
    },
  },
});
